import { gql } from 'graphql-request'

export const M_CHANGE_PLAN_TIER = gql`
  mutation ChangePlanTier($tier: String!, $annual: Boolean!) {
    changePlanTier(tier: $tier, annual: $annual) {
      ... on ChangePlanTierResult {
        success
        planName
        planTier
        interval
        dailyTokenLimit
        features
        effectiveAt
      }
      ... on MutationFailure {
        errors {
          message
        }
      }
    }
  }
`
